module.exports = "/fonts/NeoSansStd-Light.eot?a7b95d3e65e43cfbb5673c49d6be7a88";